import React, { PureComponent } from "react";

interface ISVGErase2IconProps {
  className?: string;
  size?: string | number;
  fill?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGErase2Icon extends PureComponent<
  ISVGErase2IconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 45}
        fill="#fff"           // ← 이거 고정!
        style={style}
        width="32"
        height="32"
        viewBox="0 0 40 40"
      >
        <path 
          fill="none"
          stroke="#8694B1"
          transform="translate(0 -3.125)" 
          />
      </svg>
    );
  }
}
